export const menuItems = [
  { title: "ABOUT", anchor: "#about" },
  { title: "EXPERIENCE", anchor: "#experience" },
  { title: "EDUCATION", anchor: "#education" },
  { title: "SKILLS", anchor: "#skills" },
  { title: "INTERESTS", anchor: "#interests" },
];

export const aboutSection = {
  firstName: "CHRIS",
  lastName: "BISTLINE",
  address: "NASHVILLE, TN 37206",
  phone: "(314) 650-1219",
  email: "CHRIS.BISTLINE@GMAIL.COM",
  about:
    "Software engineer, business owner and communicator with 20+ years of professional experience, spanning multiple industries. Always learning something new to solve interesting problems.",
  facebook: "https://www.facebook.com/chris.bistline",
  linkedin: "https://www.linkedin.com/in/christopher-bistline-a0999a115/",
  github: "https://github.com/csbistline",
};

export const experienceSection = [
  {
    title: "SENIOR SOFTWARE ENGINEER",
    company: "XSOLIS",
    city: "Franklin, Tenn.",
    dates: "February 2021 - Present",
    description:
      "Responsible to help drive the day to day operations of a software engineering team. Design, code, and test line of business systems and applications. Build, monitor, and maintain streaming data pipelines and system integrations. Build, monitor, and maintain RDBMS solutions. Manage and maintain AWS cloud infrastructure. Operational support of applications and technology platforms. Ensure performance, security, and availability of software solutions. Prepare technical documentation and project specifications. Ability to manage daily development tasks in Jira or similar tools. Collaborate with other team members and stakeholders. Mentor Junior Engineers.",
  },
  {
    title: "SOFTWARE DEVELOPER",
    company: "PRECISE SYSTEMS, INC",
    city: "Brentwood, Tenn.",
    dates: "August 2019 - February 2021",
    description:
      "Designed the front-end Vue.js client for new enterprise applications. Created a reusable library of functional Vue components incorporating the Vuetify component library. Practiced component-driven development using Jest. Maintained and added features to existing, mature legacy .NET web applications. Implemented modifications to back-end API and database code when needed. Trained and pair programmed with new junior developers. Followed agile workflow methodologies. Possessed a Secret Security Clearance.",
  },
  {
    title: "OWNER, DIRECTOR",
    company: "ENSLEY LLC/DELMAS LLC PROPERTIES",
    city: "Nashville, Tenn.",
    dates: "June 2013 - Present",
    description:
      "Manage portfolio of 20 residential rental property units made up of traditional long-term rentals and short-term vacation rentals. Screen tenants, perform minor maintenance, hire contractors for major repairs, manage finances, communicate with short-term guests.",
  },
  {
    title: "STUDENT WEB DEVELOPER",
    company: "VANDERBILT UNIVERSITY CODING BOOTCAMP",
    city: "Nashville, Tenn.",
    dates: "January 2019 - July 2019",
    description:
      "Studied HTML5, CSS3, JavaScript, jQuery, Bootstrap, Express.js, React.js, Node.js, Database Theory, MongoDB, MySQL, Command Line, Git, and more. This program is offered through Vanderbilt University Owen Graduate School of Management and School of Engineering, in partnership with Trilogy Education Services, Inc.",
  },
  {
    title: "SPORTS TEAM LEADER",
    company: "GANNETT NASHVILLE DESIGN STUDIO",
    city: "Nashville, Tenn.",
    dates: "May 2011 - June 2018",
    description:
      "As Sports Team Leader, managed 20+ designers and editors responsible for nightly production of 16 sports sections, MLB/NBA/NHL pages and national agate package used by all Gannett newspapers. As Senior Designer, responsible for design of news, sports and Sunday sections for two Florida newspapers.",
  },
  {
    title: "ART DIRECTOR",
    company: "TIDE MEDIA",
    city: "Johannesburg, South Africa",
    dates: "January 2005 – December 2010",
    description:
      "Managed design and production of three leading technology magazines: New Age Gaming, SA Computer Magazine and Custom PC South Africa as well as several regular supplements. Wrote video game and consumer electronics reviews. Copy edited magazines. Traveled internationally to cover video game launches.",
  },
];

export const educationSection = [
  {
    title: "VANDERBILT UNIVERSITY",
    company: "CODING BOOTCAMP",
    city: "Nashville, Tenn.",
    dates: "January 2019 - July 2019",
    description: "Full-Stack Web Development Track. Completed: July 2019",
  },
  {
    title: "INDIANA UNIVERSITY",
    company: "BA JOURNALISM",
    city: "Bloomington, Ind.",
    dates: "August 1993 - May 1997",
    description: "Secondary focus in Computer Science",
  },
];

export const interestSection = {
  description:
    "I'm a die-hard St. Louis Cardinals baseball fan. I travel to Florida every year to catch a few Spring Training games and participate in my fantasy baseball league draft, which a group of us has been doing regularly since 1996. I'm also a huge NFL and NHL fan. When I'm not sitting in front of a computer or watching sports, I enjoy cooking at home. I try to find new and interesting recipies online and try them out on my unsuspecting wife.",
};

export const skillsSection = [
  {
    icon: "mdi-aws",
    altText: "Amazon Web Services",
  },
  {
    icon: "mdi-language-typescript",
    altText: "TypeScript<br/>JavaScript",
  },
  {
    icon: "mdi-nodejs",
    altText: "NodeJS",
  },
  {
    icon: "mdi-react",
    altText: "ReactJS",
  },
  {
    icon: "mdi-vuejs",
    altText: "VueJS",
  },
  {
    icon: "mdi-apache-kafka",
    altText: "Apache Kafka",
  },
  {
    icon: "mdi-language-html5",
    altText: "HTML5",
  },
  {
    icon: "mdi-language-css3",
    altText: "CSS3",
  },
  {
    icon: "mdi-language-csharp",
    altText: "C#",
  },
  {
    icon: "mdi-dot-net",
    altText: ".NET",
  },
  {
    icon: "mdi-database",
    altText: "MSSQL<br>Postgres<br>DynamoDB<br>MongoDB<br>Firebase",
  },
  {
    icon: "mdi-git",
    altText: "Git<br>Github",
  },
  {
    icon: "mdi-test-tube",
    altText: "Jest<br>Cypress",
  },
  {
    icon: "mdi-microsoft-azure-devops",
    altText: "Microsoft Azure DevOps",
  },
  {
    icon: "mdi-jira",
    altText: "Jira<br/>BitBucket<br/>Confluence",
  },
  {
    icon: "mdi-docker",
    altText: "Docker",
  },
];
